import { render, staticRenderFns } from "./PrivacyDeleteAccount.vue?vue&type=template&id=59d50dec&scoped=true&"
import script from "./PrivacyDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./PrivacyDeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyDeleteAccount.vue?vue&type=style&index=0&id=59d50dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d50dec",
  null
  
)

export default component.exports